/* istanbul ignore file */
import { connect } from 'react-redux';
import IssueCollectorPreview from './IssueCollectorPreview';
import { getIssueCollectorData, getCustomFields } from 'js/modules/issue/actions/IssueConfigActions';
import { addNewIssue } from '../actions/IssuePreviewActions'

const mapStateToProps = (state, ownProps) => {
    const { issueConfig } = state.issueConfig;
    
    return {
        issueConfig,
        store: ownProps.store
    };
}

const mapDispatchToProps = dispatch => {
    return {
        getIssueCollectorData: (collectorData, callbackFun) => {
            dispatch( getIssueCollectorData( collectorData, callbackFun ) )
        },
        addNewIssue: data => {
            dispatch( addNewIssue( data ) )
        },
        getCustomFields: ( itemType, customFields, isSynchCustomFields, collectorId, openFrom ) => {
            dispatch( getCustomFields( itemType, customFields, isSynchCustomFields, collectorId, openFrom ) )
        }
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(IssueCollectorPreview);